/* eslint-disable react/display-name */
import dotProp from 'dot-prop-immutable';
import React from 'react';
import moment from 'moment';

import * as actionTypes from './actiontypes';
import states from './states';
import TableItemProgress from '../../../components/tableitemprogress';

const usage_details = (state = states.usage_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_USAGE_STATE: {
      return dotProp.set(state, action.path, action.payload);
    }

    case actionTypes.CONVERSATION_LOG_STATS_UPDATED: {
      return {
        ...state,
        conversation_log_stats: {
          live_chats: action.payload.totalLive,
          need_attentions: action.payload.totalRequireAttention,
          overtaken_chats: action.payload.totalOvertaken,
        },
      };
    }

    case actionTypes.CHAT_SESSION_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          chat_session_loading: true,
        }
      };
    }

    case actionTypes.CHAT_SESSION_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          chat_session_loading: false,
          chat_session_load_error: true,
        }
      };
    }

    case actionTypes.CHAT_SESSION_RECEIVED: {
      return {
        ...state,
        chat_session_time_series: action.payload && action.payload.chatSessionsTimeSeries ? action.payload.chatSessionsTimeSeries : [...state.chat_session_time_series],
        loaders: {
          ...state.loaders,
          chat_session_loading: false,
          chat_session_load_error: false,
        }
      };
    }

    case actionTypes.USER_ENGAGEMENT_STATS_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          user_stats_loading: true
        }
      };
    }

    case actionTypes.USER_ENGAGEMENT_STATS_RECEIVED: {
      return {
        ...state,
        user_engagement_stats: action.payload && action.payload.metrics ? action.payload.metrics : [...state.user_engagement_stats],
        loaders: {
          ...state.loaders,
          user_stats_loading: false,
          user_stats_load_error: false,
        }
      };
    }

    case actionTypes.USER_ENGAGEMENT_STATS_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          user_stats_loading: false,
          user_stats_load_error: true,
        }
      };
    }

    case actionTypes.USER_RETENTION_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          user_retention_loading: true,
        }
      };
    }

    case actionTypes.USER_RETENTION_RECEIVED: {
      let cohorts_columns = [...state.user_retention.cohorts_columns];
      let cohorts_data = [...state.user_retention.cohorts_data];
      if (action.payload && action.payload.cohortsColumns && action.payload.cohortsData) {
        action.payload.cohortsColumns.forEach((col) => {
          if (col.type && col.type === 'retention_value') {
            col.render = value => <TableItemProgress value={value} />
          }
          if (col.key && col.key === 'New Users') {
            col.render = text => <p className="ori-font-sm ori-font-bold">{text}</p>;
            if (action.payload.cohortsColumns.length > 21) {
              col.fixed = true;
            }
          }
          if (col.key === 'Date' && action.payload.cohortsColumns.length > 21) {
            col.fixed = true;
          }
        });
        action.payload.cohortsData.forEach((data) => {
          if (data.Date) {
            data.Date = moment(data.Date).format('DD MMM YYYY');
          }
        });
        cohorts_columns = [...action.payload.cohortsColumns];
        cohorts_data = [...action.payload.cohortsData];
      }
      return {
        ...state,
        user_retention: {
          ...state.user_retention,
          cohorts_columns,
          cohorts_data,
        },
        loaders: {
          ...state.loaders,
          user_retention_loading: false,
          user_retention_load_error: false,
        }
      };
    }

    case actionTypes.USER_RETENTION_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          user_retention_loading: false,
          user_retention_load_error: true,
        }
      };
    }

    default:
      return state;
  }
}

export default usage_details;



// WEBPACK FOOTER //
// ./src/data/redux/usage_details/reducers.js